import { render } from "./WisePage.vue?vue&type=template&id=9fee7e8c&scoped=true"
const script = {}

import "./WisePage.vue?vue&type=style&index=0&id=9fee7e8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fee7e8c"]])

export default __exports__